var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home / Share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.82503 19.225C4.45691 19.225 4.14404 19.0962 3.88643 18.8386C3.62881 18.581 3.5 18.2681 3.5 17.9V14.9C3.5 13.4225 4.01812 12.1656 5.05435 11.1293C6.09058 10.0931 7.34748 9.575 8.82503 9.575H17.2478L14.8739 7.20113C14.6246 6.95184 14.5024 6.64912 14.5071 6.29295C14.5118 5.9368 14.6424 5.63046 14.8989 5.37393C15.1482 5.12464 15.4569 5 15.825 5C16.1931 5 16.5018 5.12464 16.7511 5.37393L21.3511 9.97393C21.4794 10.1022 21.5738 10.2459 21.6343 10.4049C21.6948 10.564 21.725 10.729 21.725 10.9C21.725 11.071 21.6948 11.2361 21.6343 11.3952C21.5738 11.5542 21.4794 11.6979 21.3511 11.8261L16.7261 16.4511C16.4768 16.7004 16.1741 16.8227 15.818 16.818C15.4618 16.8133 15.1554 16.6826 14.8989 16.4261C14.6496 16.1768 14.525 15.8681 14.525 15.5C14.525 15.1319 14.6496 14.8232 14.8989 14.5739L17.2478 12.225H8.82503C8.07648 12.225 7.44351 12.4837 6.92613 13.0011C6.40873 13.5185 6.15003 14.1515 6.15003 14.9V17.9C6.15003 18.2681 6.02123 18.581 5.76363 18.8386C5.50601 19.0962 5.19314 19.225 4.82503 19.225Z",
    fill: "#385CF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrow);
export default __webpack_public_path__ + "static/media/share-arrow.62e97e372ff929e667ffef6ce0bafd79.svg";
export { ForwardRef as ReactComponent };